import axios from "axios";

export default {
  login(userData) {
    return axios({
      method: "post",
      data: userData,
      url: process.env.VUE_APP_BASE_URL_CORE + "public/jwt/login",
      headers: {
        "X-CSRF-TOKEN": "",
      },
    });
  },
  register(data) {
    return axios({
      method: "post",
      data: data,
      url: process.env.VUE_APP_BASE_URL_CORE + "public/register",
      headers: {
        "X-CSRF-TOKEN": "",
      },
    });
  },
  get(id) {
    const isV3Professional = localStorage.getItem("v3") === "true" && localStorage.getItem("role") === "PROFESSIONAL";
    const url = isV3Professional
      ? process.env.VUE_APP_BASE_URL_CORE + "auth/v3/user/" + id
      : process.env.VUE_APP_BASE_URL_CORE + "auth/user/" + id;
    return axios({
      method: "get",
      url: url,
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  getAll() {
    return axios({
      method: "get",
      url: process.env.VUE_APP_BASE_URL_CORE + "auth/users",
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  checkPassword(data) {
    return axios({
      method: "post",
      data: data,
      url: process.env.VUE_APP_BASE_URL_CORE + "auth/user/checkPassword",
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  getAllAdmin() {
    return axios({
      method: "get",
      url: process.env.VUE_APP_BASE_URL_CORE + "auth/users",
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  updateSettings(userId, data) {
    return axios({
      method: "put",
      data: data,
      url:
        process.env.VUE_APP_BASE_URL_CORE + "auth/user/" + userId + "/settings",
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
};
